exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wrapper[data-v-b7f4685a]{text-align:center;display:flex;flex-direction:row;align-items:baseline;justify-content:center}.wrapper>[data-v-b7f4685a]{margin-bottom:8px;margin-right:8px}.error[data-v-b7f4685a]{color:red}.business-id[data-v-b7f4685a]{width:200px}@media (max-width:480px){.wrapper[data-v-b7f4685a]{flex-direction:column;align-items:center}.wrapper>[data-v-b7f4685a]{margin-right:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b7f4685a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Search.vue
// module id = 416
// module chunks = 0